import type { SubscriptionTier } from "../features/subscriptions/types";

const TIER_LABELS: Record<SubscriptionTier, string> = {
  free: "Free",
  starter: "Starter",
  mid: "Mid",
  premium: "Premium",
  pro: "Pro",
  studio: "Studio",
  elite: "Elite",
};

const TIER_CLASSES: Record<SubscriptionTier, string> = {
  free: "bg-gray-100 text-gray-600 border-gray-200",
  starter: "bg-sky-50 text-sky-700 border-sky-200",
  mid: "bg-indigo-50 text-indigo-700 border-indigo-200",
  premium: "bg-amber-50 text-amber-700 border-amber-200",
  pro: "bg-violet-50 text-violet-700 border-violet-200",
  studio: "bg-fuchsia-50 text-fuchsia-700 border-fuchsia-200",
  elite: "bg-emerald-50 text-emerald-700 border-emerald-200",
};

interface TierBadgeProps {
  tier: SubscriptionTier | null;
  className?: string;
}

/** Small pill displaying the user's subscription tier. Renders nothing when tier is unknown. */
const TierBadge: React.FC<TierBadgeProps> = ({ tier, className = "" }) => {
  if (!tier) return null;
  const label = TIER_LABELS[tier] ?? tier;
  const color = TIER_CLASSES[tier] ?? TIER_CLASSES.free;
  return (
    <span
      className={`inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-semibold ${color} ${className}`}
    >
      {label}
    </span>
  );
};

export default TierBadge;
